import { Navigate, Route, Routes } from 'react-router-dom'

import { FunctionComponent } from 'react'
import RegisterPage from 'src/user/register'
import StripeCheckoutPage from 'src/stripe-checkout/stripe-checkout-page'
import ThankYouPage from 'src/stripe-checkout/thank-you'
import PaymentFailedPage from 'src/stripe-checkout/payment-failed'
import AuthCallback from './authentication/auth-callback'

/* v3 */
import Layout, {
  AdminLayout,
  CodexLayout,
  ContentPipelineLayout,
  CreatorLayout,
  ManagerLayout,
  ScribeLayout,
} from './v3/components/base-layout'
import SelfPacedLayout from './v3/self-paced/layout'
import PrivateRoute from './private-route'
import Unauthenticated from './components/unauthenticated'
import UnauthenticatedLayout from './layouts/unauthenticated-layout'
import Error404Page from './components/404-page'
import SelfPacedHome from './v3/self-paced'
import SelfPacedSearch from './v3/self-paced/search'
import ContinueWatching from './v3/self-paced/continue-watching'
import SelfPacedAssignments from './v3/self-paced/assignments'
import SelfPacedSection from './v3/self-paced/section'
import SelfPacedCourse from './v3/self-paced/course'
import SelfPacedSeries from './v3/self-paced/series'
import ClassroomPage from './v3/classroom'
import ClassroomSurveyPage from './v3/classroom/survey'
import ClassroomCertificatePage from './v3/classroom/certificate'
import ClassroomV2Page from './v3/classroom-v2'
import ClassroomV2PlayerPage from './v3/classroom-v2/course-player'
import AdminDashboard from './v3/admin/dashboard'
import UserAdministration from './v3/admin/users'
import LinkedServices from './v3/admin/linked-services'
import FoamfratConnectClients from './v3/admin/foamfrat-connect-clients'
import AdminSpecialCertifications from './v3/admin/special-certifications'
import AdminMother from './v3/admin/mother'
import CreatePage from './v3/create'
import CreateSectionPage from './v3/create/section'
import CreateCoursePage from './v3/create/course'
import CreateClassPage from './v3/create/class'
import CreateAccreditationPage from './v3/create/accreditation'
import CreateTemplatePage from './v3/create/template'
import CreateLearningPathPage from './v3/create/learning-path'
import CreateTitleScreenPage from './v3/create/title-screen'
import CreateVideosPage from './v3/create/videos'
import CreateTextContentPage from './v3/create/text-content'
import CreateQuizPage from './v3/create/quiz'
import CreateStoryboardPage from './v3/create/storyboard'
import SeriesPage from './v3/create/series'
import CreateV4Landing from './v3/create/v4'
import CourseWizard from './v3/create/v4/course'
import ClassWizard from './v3/create/v4/class'
import CreateV4Templates from './v3/create/v4/templates'
import CreateV4LearningPaths from './v3/create/v4/learning-paths'
import CreateV4Series from './v3/create/v4/series'
import MarketingSlideshows from './v3/create/v4/marketing-slideshows'
import CEAnalytics from './v3/manage/analytics/ce'
import AdvancedActivityDashboard from './v3/manage/analytics/advanced-activity-dashboard'
import V4Dashboard from './v3/manage/dashboard'
import RosterV4 from './v3/manage/roster'
import UserDetailsV4 from './v3/manage/roster/user-details'
import ManageLinkedService from './v3/manage/linked-service'
import AssignmentsV4 from './v3/manage/assignments'
import AssignmentDetailV4 from './v3/manage/assignments/detail'
import AssignmentCreateV4 from './v3/manage/assignments/create'
import AssignmentEditV4 from './v3/manage/assignments/edit'
import CourseProgress from './v3/manage/assignments/course-progress'
import AssignmentProgress from './v3/manage/assignments/assignment-progress'
import ScheduledAssignments from './v3/manage/scheduled-assignments'
import ScheduledAssignmentCreate from './v3/manage/scheduled-assignments/create'
import ScheduledAssignmentEdit from './v3/manage/scheduled-assignments/edit'
import ScheduledAssignmentDetail from './v3/manage/scheduled-assignments/detail'
import ManagerCompliance from './v3/manage/compliance'
import ComplianceCreate from './v3/manage/compliance/create'
import ComplianceDetail from './v3/manage/compliance/detail'
import ComplianceEdit from './v3/manage/compliance/edit'
import ComplianceTemplates from './v3/manage/compliance/templates'
import ManageEventsPage from './v3/manage/events'
import ManageEventDetailPage from './v3/manage/events/event-detail'
import QuizAnalyticsOverviewPage from './v3/manage/quiz-analytics'
import QuizAnalyticsLearnersPage from './v3/manage/quiz-analytics/learners'
import QuizAnalyticsDetailPage from './v3/manage/quiz-analytics/quiz-detail'
import TrainingSeriesV4 from './v3/manage/training-series'
import TrainingSeriesCreateV4 from './v3/manage/training-series/create'
import TrainingSeriesDetailV4 from './v3/manage/training-series/detail'
import TrainingSeriesEditV4 from './v3/manage/training-series/edit'
import GroupsWrapper from './v3/manage/groups/groups-wrapper'
import GroupCreateV4 from './v3/manage/groups/create'
import GroupDetailV4 from './v3/manage/groups/detail'
import GroupEditV4 from './v3/manage/groups/edit'
import LiveClassSchedule from './v3/live'
import EventsPage from './v3/events'
import EventEditPage from './v3/events/event-edit'
import EventViewPage from './v3/events/event-view'
import EventQuiz from './v3/events/take-quiz'
import EventCertificate from './v3/events/certificate'
import CreateEventPage from './v3/events/create'
import EventsV2Page from './v3/events/v2'
import EventDetailV2Page from './v3/events/v2/event-detail'
import EventQuizV2Page from './v3/events/v2/take-quiz'
import ProfileAssignments from './v3/profile/assignments'
import ProfileAssignmentsV4 from './v3/profile/assignments-v4'
import ProfileAssignmentDetailV4 from './v3/profile/assignments-v4/detail'
import ProfileCredentialsV4 from './v3/profile/v4/credentials'
import ProfileLearningPaths from './v3/profile/learning-paths'
import ProfileNewYorkLearningPaths from './v3/profile/new-york-learning-paths'
import ProfileIBSC100Renewal from './v3/profile/ibsc-100'
import ProfileIBSC40Renewal from './v3/profile/ibsc-40'
import ProfileDashboardV4 from './v3/profile/v4'
import ProfilePreferencesV4 from './v3/profile/v4/preferences'
import ProfileCertificatesV4 from './v3/profile/v4/certificates/with-layout'
import ProfileLicensesV4 from './v3/profile/v4/licenses'
import ProfileRecertificationCycles from './v3/profile/v4/recertification-cycle'
import ProfileRecertificationCycleDetail from './v3/profile/v4/recertification-cycle/cycle-detail'
import ProfileIBSCV2 from './v3/profile/v4/ibsc/with-layout'
import ProfileToursV4 from './v3/profile/v4/tours'
import ContentPipeline from './v3/content-pipeline'
import ScribeAccreditationReporting from './v3/scribe/accreditation-reporting'
import ScribeCAPCEAnalytics from './v3/scribe/capce-submission-report'
import BoundTreeRegister from './user/bound-tree-register'
import BoundTreeTrialRegister from './user/bound-tree-trial'
import BoundTreeLogin from './user/bound-tree-login'
import AuthLoginReport from './v3/scribe/auth-login-report'
import UserDemographics from './v3/scribe/user-demographics'
import CreateCourseV5 from './v3/create/v5/course'
import CourseV5Form from './v3/create/v5/course/course-form'
import CreateCourseV5Detail from './v3/create/v5/course/detail'
import VideoLibraryPage from './v3/create/v5/video-library'
import ShowNotesLibraryPage from './v3/create/v5/show-notes-library'
import ShowNotesEditPage from './v3/create/v5/show-notes'
import QuizLibraryPage from './v3/create/v5/quiz-library'
import QuizEditPage from './v3/create/v5/quiz'
import CreateSeriesV5 from './v3/create/v5/series'
import SeriesForm from './v3/create/v5/series/series-form'
import BooksPage from './v3/codex/books'
import BookEditor from './v3/codex/books/editor'
import ChapterEditor from './v3/codex/books/chapters/editor'
import ContributorsPage from './v3/codex/contributors'
import ContributorEditor from './v3/codex/contributors/editor'

let App: FunctionComponent = () => (
  <Routes>
    <Route path="/register" element={<RegisterPage />} />
    <Route path="/callback" element={<AuthCallback />} />
    <Route
      path="/boundtree"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Register">
          <BoundTreeRegister />
        </UnauthenticatedLayout>
      }
    />
    <Route
      path="/boundtree-trial"
      element={
        <UnauthenticatedLayout
          requireAuth={true}
          title="Register for Free Trial"
        >
          <BoundTreeTrialRegister />
        </UnauthenticatedLayout>
      }
    />

    <Route
      path="/subscribe-boundtree"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Subscribe">
          <StripeCheckoutPage isBoundtree={true} />
        </UnauthenticatedLayout>
      }
    />

    <Route
      path="/boundtree-login"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Login">
          <BoundTreeLogin />
        </UnauthenticatedLayout>
      }
    />
    <Route path="/" element={<Unauthenticated />} />
    <Route
      path="/subscribe"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Subscribe">
          <StripeCheckoutPage isBoundtree={false} />
        </UnauthenticatedLayout>
      }
    />
    <Route
      path="/payment-failed"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Payment failed">
          <PaymentFailedPage />
        </UnauthenticatedLayout>
      }
    />
    <Route
      path="/thank-you"
      element={
        <UnauthenticatedLayout requireAuth={true} title="Thank You!">
          <ThankYouPage />
        </UnauthenticatedLayout>
      }
    />

    {/* V3 Routes */}
    <Route
      path="/self-paced"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedHome />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/search"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedSearch />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/self-paced/continue-watching"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <ContinueWatching />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/self-paced/assignments"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedAssignments />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/self-paced/section/:sectionId"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedSection />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/self-paced/course/:courseId"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedCourse />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/self-paced/series/:seriesID"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <SelfPacedSeries />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/classroom-v2/:courseID"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <ClassroomV2Page />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/classroom-v2/:courseID/player"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <ClassroomV2PlayerPage />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/classroom/:courseID/:classID"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <ClassroomPage />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/classroom/survey/:courseID/:classID"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <ClassroomSurveyPage />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/classroom/certificate/:surveyID/:courseID/:classID"
      element={
        <PrivateRoute
          element={
            <SelfPacedLayout>
              <ClassroomCertificatePage />
            </SelfPacedLayout>
          }
        />
      }
    />
    <Route
      path="/live"
      element={
        <PrivateRoute
          element={
            <Layout>
              <LiveClassSchedule />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/events"
      element={
        <PrivateRoute
          element={
            <Layout>
              <EventsPage />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/events/create"
      element={
        <PrivateRoute
          element={
            <Layout>
              <CreateEventPage />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/events/:eventId"
      element={
        <PrivateRoute
          element={
            <Layout>
              <EventViewPage />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/events/:eventId/edit"
      element={
        <PrivateRoute
          element={
            <Layout>
              <EventEditPage />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/events/:eventId/quiz"
      element={
        <PrivateRoute
          element={
            <Layout>
              <EventQuiz />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/events/v2/:eventId/quiz"
      element={
        <PrivateRoute
          element={
            <Layout>
              <EventQuizV2Page />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/events/:eventId/certificate"
      element={
        <PrivateRoute
          element={
            <Layout>
              <EventCertificate />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/events/v2"
      element={
        <PrivateRoute
          element={
            <Layout>
              <EventsV2Page />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/events/v2/:eventId"
      element={
        <PrivateRoute
          element={
            <Layout>
              <EventDetailV2Page />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/admin"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <AdminDashboard />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/users"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <UserAdministration />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/linked-services"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <LinkedServices />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/foamfrat-connect-clients"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <FoamfratConnectClients />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/special-certifications"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <AdminSpecialCertifications />
            </AdminLayout>
          }
        />
      }
    />
    <Route
      path="/admin/mother"
      element={
        <PrivateRoute
          element={
            <AdminLayout>
              <AdminMother />
            </AdminLayout>
          }
        />
      }
    />

    <Route
      path="/create"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreatePage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/section"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateSectionPage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/course"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateCoursePage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/class"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateClassPage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/accreditation"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateAccreditationPage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/template"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateTemplatePage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/learning-path"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateLearningPathPage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/title-screen"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateTitleScreenPage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/videos"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateVideosPage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/text-content"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateTextContentPage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/quiz"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateQuizPage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/storyboard"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateStoryboardPage />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/series"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <SeriesPage />
            </CreatorLayout>
          }
        />
      }
    />

    {/* V4 Create Routes */}
    <Route
      path="/create/v4"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateV4Landing />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/v4/course"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CourseWizard />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/v4/course/:courseId"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CourseWizard />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/v4/class"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <ClassWizard />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/v4/class/:classId"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <ClassWizard />
            </CreatorLayout>
          }
        />
      }
    />
    {/* Nested Class Wizard Routes */}
    <Route
      path="/create/v4/course/:courseId/class"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <ClassWizard />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/v4/course/:courseId/class/:classId"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <ClassWizard />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/v4/templates"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateV4Templates />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/v4/learning-paths"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateV4LearningPaths />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/v4/series"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateV4Series />
            </CreatorLayout>
          }
        />
      }
    />
    <Route
      path="/create/v4/marketing-slideshows"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <MarketingSlideshows />
            </CreatorLayout>
          }
          role="creator"
        />
      }
    />

    {/* V5 Create Routes */}
    <Route
      path="/create/v5/video-library"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <VideoLibraryPage />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/show-notes-library"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <ShowNotesLibraryPage />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/show-notes/:id"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <ShowNotesEditPage />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/quiz-library"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <QuizLibraryPage />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/quiz/:id"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <QuizEditPage />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/course"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateCourseV5 />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/course/create"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CourseV5Form />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/course/:courseID/edit"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CourseV5Form />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/course/:courseID"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateCourseV5Detail />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/series"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <CreateSeriesV5 />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/series/create"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <SeriesForm />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/create/v5/series/:seriesID/edit"
      element={
        <PrivateRoute
          element={
            <CreatorLayout>
              <SeriesForm />
            </CreatorLayout>
          }
        />
      }
    />

    <Route
      path="/manage/analytics/ce"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <CEAnalytics />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <V4Dashboard />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/roster"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <RosterV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/roster/:linkedServiceID/users/:userID"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <UserDetailsV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/analytics/advanced-activity-dashboard"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <AdvancedActivityDashboard />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/linked-service"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ManageLinkedService />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/training-series"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <TrainingSeriesV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/training-series/create"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <TrainingSeriesCreateV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/training-series/:trainingSeriesID"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <TrainingSeriesDetailV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/training-series/:trainingSeriesID/edit"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <TrainingSeriesEditV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/groups"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <GroupsWrapper />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/groups/create"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <GroupCreateV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/groups/:groupID"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <GroupDetailV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/groups/:groupID/edit"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <GroupEditV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <AssignmentsV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/analytics"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <AssignmentsV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/:assignmentID"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <AssignmentDetailV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/create"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <AssignmentCreateV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/:assignmentID/edit"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <AssignmentEditV4 />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/:assignmentID/courses/:courseID/progress"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <CourseProgress />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/assignments/:assignmentID/users/:userID/progress"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <AssignmentProgress />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/scheduled-assignments"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ScheduledAssignments />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/scheduled-assignments/create"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ScheduledAssignmentCreate />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/scheduled-assignments/:scheduledAssignmentID/edit"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ScheduledAssignmentEdit />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/scheduled-assignments/:scheduledAssignmentID"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ScheduledAssignmentDetail />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/compliance"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ManagerCompliance />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/compliance/create"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ComplianceCreate />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/compliance/templates"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ComplianceTemplates />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/compliance/:id"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ComplianceDetail />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/compliance/:id/edit"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ComplianceEdit />
            </ManagerLayout>
          }
        />
      }
    />

    <Route
      path="/manage/events"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ManageEventsPage />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/events/:eventID"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <ManageEventDetailPage />
            </ManagerLayout>
          }
        />
      }
    />

    <Route
      path="/manage/quiz-analytics"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <QuizAnalyticsOverviewPage />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/quiz-analytics/learners"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <QuizAnalyticsLearnersPage />
            </ManagerLayout>
          }
        />
      }
    />
    <Route
      path="/manage/quiz-analytics/:quizID"
      element={
        <PrivateRoute
          element={
            <ManagerLayout>
              <QuizAnalyticsDetailPage />
            </ManagerLayout>
          }
        />
      }
    />

    <Route
      path="/profile/assignments"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileAssignments />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/assignments"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileAssignmentsV4 />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/assignments/:assignmentId"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileAssignmentDetailV4 />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/learning-paths"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileLearningPaths />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/new-york-learning-paths"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileNewYorkLearningPaths />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/ibsc"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileIBSCV2 />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/ibsc-100"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileIBSC100Renewal />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/ibsc-40"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileIBSC40Renewal />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileDashboardV4 />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/preferences"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfilePreferencesV4 />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/certificates"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileCertificatesV4 />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/learning-overview"
      element={<Navigate to="/profile/certificates" replace />}
    />
    <Route
      path="/profile/licenses"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileLicensesV4 />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/credentials"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileCredentialsV4 />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/recertification"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileRecertificationCycles />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/recertification/cycle/:cycleID"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileRecertificationCycleDetail />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/profile/tours"
      element={
        <PrivateRoute
          element={
            <Layout>
              <ProfileToursV4 />
            </Layout>
          }
        />
      }
    />
    <Route
      path="/pipeline"
      element={
        <PrivateRoute
          element={
            <ContentPipelineLayout>
              <ContentPipeline />
            </ContentPipelineLayout>
          }
        />
      }
    />
    <Route
      path="/pipeline/planning"
      element={
        <PrivateRoute
          element={
            <ContentPipelineLayout>
              <ContentPipeline />
            </ContentPipelineLayout>
          }
        />
      }
    />
    <Route
      path="/pipeline/compliance"
      element={
        <PrivateRoute
          element={
            <ContentPipelineLayout>
              <ContentPipeline />
            </ContentPipelineLayout>
          }
        />
      }
    />
    <Route
      path="/pipeline/performance"
      element={
        <PrivateRoute
          element={
            <ContentPipelineLayout>
              <ContentPipeline />
            </ContentPipelineLayout>
          }
        />
      }
    />
    <Route
      path="/pipeline/accreditation"
      element={
        <PrivateRoute
          element={
            <ContentPipelineLayout>
              <ContentPipeline />
            </ContentPipelineLayout>
          }
        />
      }
    />
    <Route
      path="/pipeline/instructor"
      element={
        <PrivateRoute
          element={
            <ContentPipelineLayout>
              <ContentPipeline />
            </ContentPipelineLayout>
          }
        />
      }
    />
    <Route
      path="/scribe/sentiment-analysis"
      element={
        <PrivateRoute
          element={
            <ScribeLayout>
              <ScribeAccreditationReporting />
            </ScribeLayout>
          }
        />
      }
    />
    <Route
      path="/scribe/capce-submission-report"
      element={
        <PrivateRoute
          element={
            <ScribeLayout>
              <ScribeCAPCEAnalytics />
            </ScribeLayout>
          }
        />
      }
    />
    <Route
      path="/scribe/auth-login-report"
      element={
        <PrivateRoute
          element={
            <ScribeLayout>
              <AuthLoginReport />
            </ScribeLayout>
          }
        />
      }
    />
    <Route
      path="/scribe"
      element={
        <PrivateRoute
          element={
            <ScribeLayout>
              <UserDemographics />
            </ScribeLayout>
          }
        />
      }
    />
    <Route
      path="/codex/books"
      element={
        <PrivateRoute
          element={
            <CodexLayout>
              <BooksPage />
            </CodexLayout>
          }
        />
      }
    />
    <Route
      path="/codex/books/:id"
      element={
        <PrivateRoute
          element={
            <CodexLayout>
              <BookEditor />
            </CodexLayout>
          }
        />
      }
    />
    <Route
      path="/codex/books/:bookID/chapters/:chapterID"
      element={
        <PrivateRoute
          element={
            <CodexLayout>
              <ChapterEditor />
            </CodexLayout>
          }
        />
      }
    />
    <Route
      path="/codex/contributors"
      element={
        <PrivateRoute
          element={
            <CodexLayout>
              <ContributorsPage />
            </CodexLayout>
          }
        />
      }
    />
    <Route
      path="/codex/contributors/:contributorID"
      element={
        <PrivateRoute
          element={
            <CodexLayout>
              <ContributorEditor />
            </CodexLayout>
          }
        />
      }
    />
    <Route
      path="/*"
      element={
        <UnauthenticatedLayout title="Page Not Found">
          <Error404Page />
        </UnauthenticatedLayout>
      }
    />
  </Routes>
)

export default App
